import React, { PropTypes } from 'react';

import './styles.scss';

const noop = () => {};

export const Button = props => (
  <button
    className={`${props.className} originalButton`}
    onClick={props.onClick}
    onMouseDown={props.onMouseDown}
    onTouchStart={props.onTouchStart}
    type={props.type}
    disabled={props.disabled}
  >
    <div className="content-container">
      {props.children}
    </div>
  </button>
);

Button.defaultProps = {
  onTouchStart: noop,
  onMouseDown: noop,
  onClick: noop,
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/button/main.jsx